import { render, staticRenderFns } from "./UsersPermissions.vue?vue&type=template&id=7fe69718"
import script from "./UsersPermissions.vue?vue&type=script&lang=js"
export * from "./UsersPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports